import { SiriusComponentModel } from 'sirius-framework';


export class SalesTransactionInformationModel extends SiriusComponentModel {
    SellerMernisNo: string;
    SellerName: string;  
    SellerIban: string; 
    Plate: string;     
    BuyerPhone: string;
    SalesAmount: number; 
    ResultID: string;
    ResultIDGoi: string;
    CustomerType: string;
    ResultMessage: string;
    ResultCode: number;
}

